module.exports = __webpack_public_path__ + "img/default-background.d75132c6.jpg";